module.exports = __webpack_public_path__ + "static/media/1.7d265600.JPG";